/* OPTION C (Oct 13, Vlad's chain board, jarvis 21988), chain item pages only (#pdp-b.pdp-c).
   1. About this item: six tiles from the six numbered points' lead lines, above the card.
   2. Description: the description's own sections as tabs (Overview, then each bolded lead: Details, Size & fit, Care,
      Buying it), the Where it sits card on the right.
   3. (not built, see below) the board's tabbed More men's chains shelf.
   Everything works from what the page already prints; with no script the page reads as before. */
(function () {
  var R = document.getElementById('pdp-b');
  if (!R || !R.classList.contains('pdp-c')) return;
  /* the board's own icons (stroke #8C6A22, width 1.8) */
  var SV = function (d) { return '<svg viewBox="0 0 24 24" aria-hidden="true">' + d + '</svg>'; };
  var ICONS = {
    gem: SV('<path d="M12 3 4 8l8 13 8-13-8-5z"/><path d="M4 8h16"/>'),
    width: SV('<path d="M4 12h16"/><path d="m7 9-3 3 3 3"/><path d="m17 9 3 3-3 3"/>'),
    sparkle: SV('<path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M6 18l2.5-2.5M15.5 8.5 18 6"/>'),
    ruler: SV('<path d="M3 17 17 3l4 4L7 21z"/><path d="m7 13 2 2M10 10l2 2M13 7l2 2"/>'),
    weight: SV('<path d="M6 9h12l2 11H4L6 9z"/><circle cx="12" cy="6" r="2.5"/>'),
    store: SV('<path d="M4 10h16v10H4z"/><path d="M3 10 5 4h14l2 6"/><path d="M10 20v-5h4v5"/>'),
    drop: SV('<path d="M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11z"/>'),
    shield: SV('<path d="M12 3 5 6v6c0 4.5 3 7.5 7 9 4-1.5 7-4.5 7-9V6l-7-3z"/><path d="m9 12 2 2 4-4"/>')
  };
  /* which board icon a point gets, by what the point is about */
  function tileIcon(t) {
    t = t.toLowerCase();
    if (/listed for|sold and shipped|traxnyc|since 20/.test(t)) return 'store';
    if (/\b(1[048]|2[24])k\b|karat|gold|silver|platinum/.test(t) && !/\bwide\b|length|gram/.test(t)) return 'gem';
    if (/length|inch/.test(t)) return 'ruler';
    if (/\bwide\b|width/.test(t)) return 'width';
    if (/hollow|solid|semi|gram|weigh|build/.test(t)) return 'weight';
    if (/sparkle|strand|twist|shine|diamond-cut|light from/.test(t)) return 'sparkle';
    return 'gem';
  }

  function txt(el) { return (el && el.textContent || '').replace(/\s+/g, ' ').trim(); }

  /* 0. The top and the buy box, as the board has them */
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function affirmOpen(id) { return function (e) { e.preventDefault(); var t = document.querySelector('#' + id + ' .affirm-modal-trigger') || document.querySelector('.affirm-modal-trigger'); if (t) t.click(); }; }
  try {
    // item number beside the NEW ARRIVALS badge
    var item = R.querySelector('.mk-buy-item'), badges = R.querySelector('.mk-badges');
    if (item && R.querySelector('.oc-item')) { item.hidden = true; }  // printed beside the badges by pdp-item-top (Nov 2)
    else if (item) {
      if (!badges) { badges = el('div', 'mk-badges'); var h1 = R.querySelector('h1'); var st0 = R.querySelector('.mk-head a[href="#reviews"]'); (st0 || h1).parentNode.insertBefore(badges, (st0 || h1).nextSibling); }
      var it = el('span', 'oc-item'); it.textContent = txt(item); badges.appendChild(it); item.hidden = true;
    }
    // store line: Store 4.83 from N reviews (Judge.me, store-wide)
    [].forEach.call(R.querySelectorAll('.mk-head a[href="#reviews"]'), function (a) {
      if (/Store Rating/.test(a.textContent)) { a.innerHTML = a.innerHTML.replace('Store Rating', 'Store') ; a.insertAdjacentHTML('beforeend', ' <small class="oc-muted">(Judge.me, store-wide)</small>'); }
    });
    // under the price: Bank Wire (3% off) · Affirm see if you qualify · Crypto, in place of Affirm's own line
    var am = document.getElementById('affirm-msg');
    if (am && !R.querySelector('.oc-payline')) {
      var pl = el('div', 'oc-payline', '<span><b>Bank Wire</b> (3% off)</span><span><b>Affirm</b> <a href="#" class="oc-q">see if you qualify</a></span><span><b>Crypto</b></span>');
      pl.querySelector('.oc-q').addEventListener('click', affirmOpen('affirm-msg'));
      am.parentNode.insertBefore(pl, am); am.classList.add('oc-hide');
    }
    // buy box: Add to cart, Buy now, (Make an offer where the page decides), Text A Jeweler; the phone line; no wallet buttons
    var buy = R.querySelector('.mk-buy');
    if (buy) {
      [].forEach.call(buy.querySelectorAll('.mk-btn'), function (b) {
        var t = txt(b);
        // Make an offer stays wherever the item page puts it: pdp-item.liquid decides (offer_on: in the price row for the
        // families in the item page switch's offer list, else in the buy box)
        if (/^Ask a jeweler$/i.test(t)) { b.innerHTML = b.innerHTML.replace(/Ask a jeweler/i, 'Text A Jeweler'); }
      });
      var wal = buy.querySelector('#ipwal, .mk-wallets'); if (wal) wal.classList.add('oc-hide');
      var tl = buy.querySelector('.mk-textline');
      if (tl) tl.innerHTML = '<a class="oc-phone" href="tel:+12128729692" data-t="call">212-872-9692</a> <span class="oc-muted">· call or text</span>';
      var ways = buy.querySelector('.mk-ways');
      if (ways) {
        var h = ways.querySelector('h3'); if (h) h.textContent = 'Ways to pay';
        [].forEach.call(ways.querySelectorAll('.mk-way'), function (w) {
          var k = txt(w.querySelector('b')).toLowerCase(), v = w.querySelector('span');
          if (!v) return;
          if (k === 'affirm') { var ap = v.querySelector('.affirm-as-low-as'); var nv = el('span', '', 'Pay Over Time<br><a href="#" class="oc-q">see if you qualify</a>'); nv.querySelector('.oc-q').addEventListener('click', affirmOpen(ap && ap.id || 'affirm-msg')); if (ap) { ap.classList.add('oc-hide'); nv.appendChild(ap); } w.replaceChild(nv, v); }
          else if (k === 'bank wire') v.textContent = '3% Off The Price';
          else if (k === 'crypto') v.innerHTML = '<a class="oc-q" href="sms:+12128729692" data-t="text" data-ip-chat="crypto">Text A Jeweler</a>';
        });
      }
    }
  } catch (e) {}

  /* Compare: the board puts the same build in the other karat before the solid version */
  try {
    var tb = R.querySelector('#mk-compare table');
    if (tb) {
      var heads = tb.querySelectorAll('thead th .mk-slot');
      if (heads.length >= 2) {
        var a1 = txt(heads[heads.length - 2]).toLowerCase(), a2 = txt(heads[heads.length - 1]).toLowerCase();
        if (/solid/.test(a1) && /same/.test(a2)) {
          [].forEach.call(tb.querySelectorAll('tr'), function (tr) { var c = tr.children; if (c.length >= 4) tr.insertBefore(c[c.length - 1], c[c.length - 2]); });
        }
      }
    }
  } catch (e) {}

  /* 1. About: out of the top grid to a full-width section under it, then the tiles */
  try {
    var about = document.getElementById('mk-about'), top = R.querySelector('.mk-top');
    if (about && top && about.parentNode === top) top.parentNode.insertBefore(about, top.nextSibling);
    var ol = document.getElementById('aboutlist');
    if (ol) {
      var rank = { gem: 0, width: 1, sparkle: 2, ruler: 3, weight: 4, store: 5 };
      var lis = [].slice.call(ol.children).map(function (li, i) { return { li: li, r: rank[tileIcon(txt(li.querySelector('b, strong')))] , i: i }; });
      lis.sort(function (x, y) { return (x.r - y.r) || (x.i - y.i); }).forEach(function (o) { ol.appendChild(o.li); });
    }
  } catch (e) {}
  try {
    var card = R.querySelector('.mk-about-card');
    var items = R.querySelectorAll('#aboutlist > li');
    if (card && items.length >= 3 && !R.querySelector('.oc-tiles')) {
      var ul = document.createElement('ul'); ul.className = 'oc-tiles';
      [].forEach.call(items, function (li, i) {
        if (i > 5) return;
        var b = li.querySelector('b, strong'); var t = txt(b).replace(/\.$/, '');
        if (!t) return;
        var tile = document.createElement('li'); tile.className = 'oc-tile';
        tile.innerHTML = ICONS[tileIcon(t)]; var s = document.createElement('span'); s.textContent = t; tile.appendChild(s);
        ul.appendChild(tile);
      });
      if (ul.children.length >= 3) card.parentNode.insertBefore(ul, card);
    }
  } catch (e) {}

  /* 2. Description tabs */
  try {
    var sec = document.getElementById('mk-desc');
    var body = sec && sec.querySelector('.mk-desc');
    if (body && !sec.querySelector('.oc-desc') && !sec.classList.contains('mk-desctop')) {  /* Oct 30: not the description beside the buy box */
      var ps = [].slice.call(body.children);
      var groups = []; var tail = [];
      ps.forEach(function (p) {
        var lead = p.firstElementChild && /^(B|STRONG)$/.test(p.firstElementChild.tagName) && p.textContent.indexOf(txt(p.firstElementChild)) <= 1 ? p.firstElementChild : null;
        if (/^see more\b/i.test(txt(p))) { tail.push(p); return; }
        if (lead) groups.push({ lead: txt(lead), nodes: [p] });
        else if (!groups.length) { groups.push({ lead: '', nodes: [p] }); }
        else groups[groups.length - 1].nodes.push(p);
      });
      if (groups.length >= 3) {
        var name = function (l, i) {
          if (!l) return 'Overview';
          var n = l.replace(/[.:]+$/, '').replace(/^the\s+/i, '').replace(/\s+and\s+/i, ' & ');
          return n.charAt(0).toUpperCase() + n.slice(1);
        };
        var icon = function (n) { n = n.toLowerCase(); return /size|fit|length/.test(n) ? 'ruler' : /care|clean/.test(n) ? 'drop' : /buy|ship|return|warrant/.test(n) ? 'shield' : 'gem'; };
        var wrap = document.createElement('div'); wrap.className = 'oc-desc';
        var left = document.createElement('div');
        var tabs = document.createElement('div'); tabs.className = 'oc-tabs'; tabs.setAttribute('role', 'tablist'); tabs.setAttribute('aria-label', 'Description');
        left.appendChild(tabs);
        groups.forEach(function (g, i) {
          var nm = name(g.lead, i);
          var b = document.createElement('button'); b.type = 'button'; b.className = 'oc-tab'; b.textContent = nm;
          b.setAttribute('role', 'tab'); b.id = 'oc-tab-' + i; b.setAttribute('aria-controls', 'oc-pane-' + i); b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
          tabs.appendChild(b);
          var pane = document.createElement('div'); pane.className = 'oc-pane'; pane.id = 'oc-pane-' + i; pane.setAttribute('role', 'tabpanel'); pane.setAttribute('aria-labelledby', b.id);
          if (i) pane.hidden = true;
          var ic = document.createElement('div'); ic.className = 'oc-pane-ic'; ic.innerHTML = ICONS[icon(nm)];
          var col = document.createElement('div'); var h = document.createElement('div'); h.className = 'oc-pane-t'; h.textContent = nm; col.appendChild(h);
          g.nodes.forEach(function (n) { col.appendChild(n); });
          pane.appendChild(ic); pane.appendChild(col); left.appendChild(pane);
        });
        tail.forEach(function (n) { left.appendChild(n); });
        tabs.addEventListener('click', function (e) {
          var t = e.target.closest && e.target.closest('.oc-tab'); if (!t) return;
          [].forEach.call(tabs.children, function (x) { var on = x === t; x.setAttribute('aria-selected', on ? 'true' : 'false'); document.getElementById(x.getAttribute('aria-controls')).hidden = !on; });
        });
        body.innerHTML = ''; body.appendChild(left);
        wrap.appendChild(body);
        var ws = sec.querySelector('.ws'); if (ws) wrap.appendChild(ws);
        sec.insertBefore(wrap, sec.querySelector('h2').nextSibling);
      }
    }
  } catch (e) {}

  /* 3. More men's chains (the board's tabbed shelf) is NOT built: it would load the pieces by script and hide the
     "More rope chains" row, so Google would see fewer product links on chain pages (Dima, Oct 13). The page keeps its
     printed family links and its More rope chains row. */
})();
